import { Link } from "react-router-dom";
import {
  Box,
  Button,
  CardMedia,
  Container,
  Typography,
  useTheme,
} from "@mui/material";

import { ROUTES } from "@/utils/navigation";
import useResponsive from "@/hooks/useResponsive";

import map_submenu_sm from "@/assets/images/about-us/map-submenu-sm.png";
import map_submenu_lg from "@/assets/images/about-us/map-submenu-lg.jpg";

const Explore = () => {
  const theme = useTheme();
  const isMobile = useResponsive("down", "md");

  return (
    <Box
      component="section"
      pt={{ xs: 5, md: 6, lg: 12.5 }}
      pb={{ xs: 5, md: 6, lg: 12.5 }}
      color={theme.palette.text.primary}
      bgcolor={{ xs: "background.default", md: "white" }}
    >
      <Container>
        <Box
          pt={{ xs: 0, md: 6, lg: 8 }}
          pb={0}
          bgcolor="background.default"
          px={{ xs: 0, md: 6, lg: 9.25 }}
          borderRadius="20px"
          position="relative"
        >
          <Typography color="text.primary" variant="h2" mb={{ xs: 3, md: 5 }}>
            <Typography variant="h2" color="text.accent" component="span">
              Explore, Connect,
            </Typography>{" "}
            and{" "}
            <Typography variant="h2" color="text.accent" component="span">
              Navigate
            </Typography>{" "}
            with Trackmate
          </Typography>

          <Typography
            variant="subtitle1"
            component="p"
            color="text.primary"
            sx={{ fontSize: { xs: 16, md: 18, lg: 20 } }}
            textAlign="end"
          >
            — together, we redefine the
          </Typography>
          <Typography
            variant="subtitle1"
            component="p"
            color="text.primary"
            sx={{ fontSize: { xs: 16, md: 18, lg: 20 } }}
            textAlign="end"
            mb={{ xs: 3, md: 6, lg: 11.5 }}
          >
            way we track our world
          </Typography>

          <Box
            sx={{
              borderTopLeftRadius: "20px",
              borderTopRightRadius: "20px",
              overflow: "hidden",
            }}
            mb={{ xs: 4, md: 0 }}
            display="flex"
            justifyContent="center"
          >
            <CardMedia
              component="img"
              loading="lazy"
              image={isMobile ? map_submenu_sm : map_submenu_lg}
              alt="building"
              width="100%"
              height="auto"
              sx={{ maxWidth: { xs: 425, md: "100%" } }}
            />
          </Box>

          <Box display="flex" justifyContent="center">
            <Button
              variant="contained"
              size="large"
              disableElevation
              component={Link}
              to={ROUTES.subscriptionPlans}
              sx={{
                width: 222,
                position: {
                  xs: "static",
                  md: "absolute",
                  bottom: "5%",
                },
              }}
            >
              Get started
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Explore;
